module.exports = __webpack_public_path__ + "static/media/test2_2.ba7ac5e0.png";